import { render, staticRenderFns } from "./AttivaOfferta.vue?vue&type=template&id=26a8aca4&scoped=true"
import script from "./AttivaOfferta.vue?vue&type=script&lang=js"
export * from "./AttivaOfferta.vue?vue&type=script&lang=js"
import style0 from "./AttivaOfferta.vue?vue&type=style&index=0&id=26a8aca4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a8aca4",
  null
  
)

export default component.exports